import { IconButton } from "@radix-ui/themes";
import { MediaPlayer } from "dashjs";
import { useEffect, useState } from "react";
import { useMediaPlayer } from "@/shared/ui";
import { ReactComponent as PauseIcon } from "./icons/pause-filled.svg";
import { ReactComponent as PlayIcon } from "./icons/play-filled.svg";

export function PlayPauseButton() {
  const mediaPlayer = useMediaPlayer();
  const [isPlaying, setIsPlaying] = useState(false);

  const onPaused = () => {
    setIsPlaying(false);
  };

  const onPlaying = () => {
    setIsPlaying(true);
  };

  useEffect(() => {
    mediaPlayer.on(MediaPlayer.events.PLAYBACK_PAUSED, onPaused);
    mediaPlayer.on(MediaPlayer.events.PLAYBACK_PLAYING, onPlaying);

    return () => {
      mediaPlayer.off(MediaPlayer.events.PLAYBACK_PAUSED, onPaused);
      mediaPlayer.off(MediaPlayer.events.PLAYBACK_PLAYING, onPlaying);
    };
  }, [isPlaying]);

  return (
    <IconButton
      variant="ghost"
      size="2"
      color="gray"
      highContrast
      onClick={() => {
        if (mediaPlayer.isPaused()) {
          mediaPlayer.play();
        } else {
          mediaPlayer.pause();
        }
      }}
    >
      {isPlaying ? (
        <PauseIcon className="w-5 h-5" />
      ) : (
        <PlayIcon className="w-5 h-5" />
      )}
    </IconButton>
  );
}
